/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LanguageCultureInfoDto,
  TimeZoneInfoDto,
} from '../models/index';
import {
    LanguageCultureInfoDtoFromJSON,
    LanguageCultureInfoDtoToJSON,
    TimeZoneInfoDtoFromJSON,
    TimeZoneInfoDtoToJSON,
} from '../models/index';

export interface GetLanguageTranslationsRequest {
    lang: string;
    live?: boolean;
}

/**
 * 
 */
export class LocalizationApi extends runtime.BaseAPI {

    /**
     */
    async getLanguageTranslationsRaw(requestParameters: GetLanguageTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.lang === null || requestParameters.lang === undefined) {
            throw new runtime.RequiredError('lang','Required parameter requestParameters.lang was null or undefined when calling getLanguageTranslations.');
        }

        const queryParameters: any = {};

        if (requestParameters.live !== undefined) {
            queryParameters['live'] = requestParameters.live;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/localization/languages/{lang}/translations`.replace(`{${"lang"}}`, encodeURIComponent(String(requestParameters.lang))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getLanguageTranslations(requestParameters: GetLanguageTranslationsRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getLanguageTranslationsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<string>(response, errorHandlers);
    }

    /**
     */
    async getLanguagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LanguageCultureInfoDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/localization/languages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LanguageCultureInfoDtoFromJSON));
    }

    /**
     */
    async getLanguages(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getLanguagesRaw(initOverrides);
        return this.configuration.handleFunction<Array<LanguageCultureInfoDto>>(response, errorHandlers);
    }

    /**
     */
    async getTimesZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TimeZoneInfoDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/localization/time-zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TimeZoneInfoDtoFromJSON));
    }

    /**
     */
    async getTimesZones(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTimesZonesRaw(initOverrides);
        return this.configuration.handleFunction<Array<TimeZoneInfoDto>>(response, errorHandlers);
    }

}
